import "core-js/modules/es6.object.assign";
import _defineProperty from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.function.name";

var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import config from '@/config';
import { pests } from '@/api/api_url';
import { getToken, formatYMD } from '@/libs/util';
import { renderFormMixins } from '@/mixins/renderFormMixins';
import { building_list, floor_list, maintenance_report } from '@/api/pests';
import commonDetails from './commonDetails.vue';
export default {
  name: "customDetails",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      project_name: null,
      address: null,
      customer_user: null,
      tel: null,
      maintenance_type: null,
      maintenance_user: null,
      handle_time: null,
      maintenance_area: [],
      maintenance_info: {},
      currId: null,
      maintenance_material: [],
      maintenance_medicine: [],
      axis: [],
      //已存在坐标
      imageSrc: null,
      floorListData: [],
      //楼层列表
      buildingListData: [],
      //建筑物列表
      projectListData: [],
      //项目记录
      alarmTypeData: [],
      //设备分类
      statusData: [{
        value: 2,
        label: '审核通过'
      }, {
        value: 3,
        label: '审核未通过'
      }],
      //设备用途
      defaultList: [],
      maintainList: [],
      center: {
        lng: 0,
        lat: 0
      },
      zoom: 3,
      BMap: null,
      position: {
        lng: 0,
        lat: 0
      },
      uploadList: [],
      refName: 'refName',
      headers: {
        Authorization: getToken()
      },
      hasDisabled: true,
      fileName: 'image',
      fileData: {
        client_id: ""
      },
      format: ['jpg', 'jpeg', 'png'],
      visible: false,
      imgName: '',
      uploadData: {
        client_id: null
      },
      uploadHeaders: {
        "Authorization": getToken()
      },
      proAttrFile: {},
      formModel: {
        status: null,
        audit_remark: null,
        audit_user: null,
        handle_time: null
      },
      formRules: {
        handle_time: [{
          required: true,
          message: '处理时间不能为空',
          trigger: 'change'
        }],
        status: [{
          required: true,
          message: '审核状态不能为空',
          trigger: 'blur'
        }],
        audit_remark: [{
          required: true,
          message: '审核说明不能为空',
          trigger: 'change'
        }],
        audit_user: [{
          required: true,
          message: '审核人员不能为空',
          trigger: 'change'
        }]
      }
    };
  },
  props: {
    _vm: {},
    edit: {},
    '$store': {},
    setData: {}
  },
  components: {
    commonDetails: commonDetails
  },
  computed: {
    getAction: function getAction() {
      var result = '';

      if (process.env.NODE_ENV === 'development') {
        result = config.baseUrl.dev + "" + pests.upload_file;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        result = config.baseUrl.pro + "" + pests.upload_file;
      } else {
        result = config.baseUrl.alp + "" + pests.upload_file;
      }

      return result;
    }
  },
  methods: (_methods = {
    timeChange: function timeChange(val) {
      this.$set(this.formModel, 'handle_time', val);
    },

    /**
     * 获取楼层
     */
    getFloor: function getFloor(val, callback) {
      for (var i = 0; i < this.floorListData.length; i++) {
        var list = this.floorListData[i];

        if (val === list.floor_code) {
          this.imageSrc = list.file_url;
          break;
        }
      }

      if (callback) {
        callback();
      }
    },

    /**
     * 获取坐标
     */
    getAxis: function getAxis(axis) {
      this.$set(this.formModel, 'x_axis', axis.x);
      this.$set(this.formModel, 'y_axis', axis.y);
    },

    /**
     * 项目改变
     */
    changeProject: function changeProject(val, callback) {
      var _this = this;

      this.$set(this.formModel, 'building_code', null);
      this.$set(this.formModel, 'floor_code', null);
      building_list({
        page: 0,
        page_size: 15,
        project_code: val
      }).then(function (res) {
        if (res.result === 0) {
          _this.buildingListData = res.body.list || [];

          if (callback) {
            callback();
          }
        } else {}
      });
    },

    /**
     * 改变建筑物
     */
    changeBuilding: function changeBuilding(val, callback) {
      var _this2 = this;

      this.$set(this.formModel, 'floor_code', null);
      floor_list({
        page: 0,
        page_size: 15,
        building_code: val
      }).then(function (res) {
        if (res.result === 0) {
          _this2.floorListData = res.body.list || [];

          if (callback) {
            callback();
          }
        }
      });
    },
    handleView: function handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    handleRemove: function handleRemove(file) {
      var fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
    },
    handleMaxSize: function handleMaxSize(file) {
      this.$Notice.warning({
        title: '文件大小超出限制',
        desc: '请上传小于4M的图片'
      });
    },
    handleBeforeUpload: function handleBeforeUpload(file) {
      return true;
    },

    /**
     * 上传进度
     */
    handleProgess: function handleProgess(event, file, fileList) {},

    /**
     * 维保开始日期
     */
    startChange: function startChange(val) {
      this.$set(this.formModel, 'maintain_start', val);
    },

    /**
     * 合同开始日期
     */
    contractTimeChange: function contractTimeChange(arr) {
      this.$set(this.formModel, 'contract_start', arr[0]);
      this.$set(this.formModel, 'contract_end', arr[1]);
    },
    //检查图片的width和height
    checkImageWH: function checkImageWH(file, width, height) {
      var self = this._vm;
      return new Promise(function (resolve, reject) {
        var filereader = new FileReader();

        filereader.onload = function (e) {
          var src = e.target.result;
          var image = new Image();

          image.onload = function () {
            if (width && this.width != width) {
              self.$Notice.error({
                title: self.$t('operationModule.uploadFileFormatTitleWidth') + width
              });
              reject();
              self.spinShow = false;
            } else if (height && this.height != height) {
              self.$Notice.error({
                title: self.$t('operationModule.uploadFileFormatTitleHeight') + height
              });
              reject();
              self.spinShow = false;
            } else {
              resolve();
            }
          };

          image.onerror = reject;
          image.src = src;
        };

        filereader.readAsDataURL(file);
      });
    },

    /**
     * 上传之前检查width,height
     */
    handleUploadImg: function handleUploadImg(file, width, height) {
      return this.checkImageWH(file, width, height);
    }
  }, _defineProperty(_methods, "handleRemove", function handleRemove(file, fileList, str) {
    this.$set(this.formModel, 'company_avatar', '');
    this.uploadList.splice(0);
  }), _defineProperty(_methods, "handleSuccess", function handleSuccess(res, file, str) {
    var vm = this;
    this.uploadList.splice(0);

    if (res.result === 0) {
      //to do
      this.$set(this.formModel, 'file_path', res.body.file_path);
      this.uploadList.push({
        status: 'finished',
        url: res.body.file_path,
        name: file.name
      });
    } else {
      //删除上传的对象
      this.$Message.error(res.errorMsg);
    }
  }), _defineProperty(_methods, "clientChange", function clientChange(val) {
    this.$set(this.fileData, 'client_id', val);
    this.hasDisabled = false;
  }), _defineProperty(_methods, "handleView", function handleView(name) {
    this.imgName = name;
    this.visible = true;
  }), _defineProperty(_methods, "handleFormatError", function handleFormatError(file) {
    this.$Notice.warning({
      title: '文件格式错误',
      desc: '请上传' + this.format.join(', ') + '类型文件'
    });
  }), _defineProperty(_methods, "init", function init() {
    /**
     * 获取维保报告
     */
    // maintenance_report({id:this.currId}).then(res=>{
    //   if(res.result===0){
    //   this.project_name=res.body.project_name
    //   this.address=res.body.address;
    //   this.customer_user=res.body.customer_user
    //   this.tel=res.body.tel
    //   this.maintenance_type=res.body.maintenance_type
    //   this.maintenance_user=res.body.maintenance_user
    //   this.handle_time=res.body.handle_time
    //     this.maintenance_area=res.body.maintenance_area
    //     this.maintenance_info=res.body.maintenance_info
    //     this.maintenance_material=res.body.maintenance_material
    //     this.maintenance_medicine=res.body.maintenance_medicine
    //   }else{
    //   }
    // })
  }), _methods),
  mounted: function mounted() {
    debugger;

    if (this.edit) {
      if (this.setData) {
        Object.assign(this.formModel, this.setData);
        this.currId = this.setData.id;
      }
    }

    this.init();
  },
  created: function created() {// this.init()
  }
};